const stopVideo = (mdl) => {
  if (mdl.find('iframe').length) {
    let iframe = mdl.find('iframe'),
      iframeSrc = iframe.attr('src');
    iframe.attr('src', '');
    iframe.attr('src', iframeSrc);
  }

  if (mdl.find('video').length) {
    mdl.find('video').trigger('pause');
  }
};

$(document).on('click', '.w-mdl-close', function () {
  let mdlVideo = $('.js-mdl-video-tour');
  if (mdlVideo.length && mdlVideo.hasClass('active')) {
    stopVideo(mdlVideo);
  }
});
